import { render, staticRenderFns } from "./Process.vue?vue&type=template&id=3d9db3b5&lang=pug&"
import script from "./Process.vue?vue&type=script&lang=ts&"
export * from "./Process.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Process.vue"
export default component.exports